import type {
  JournalSortData,
  CityOrCountry,
  Geo as EncodedGeo,
  ArticlesData,
} from '@/shared/api/experience/types.gen';
import type { Article, Geo, geoKey } from '@/shared/models/journal';

export const normalizeGeoKey = (encoded: CityOrCountry): geoKey => ({
  id: encoded.id,
  name: encoded.name ?? '',
  slug: encoded.slug ?? '',
  url: encoded.url ?? '',
});

export const normalizeGeo = (encoded: EncodedGeo): Geo => ({
  city: encoded.city?.map((city) => normalizeGeoKey(city)),
  country: encoded.country?.map((country) => normalizeGeoKey(country)),
});

export const normalizeArticle = (encoded: JournalSortData | ArticlesData): Article => {
  return {
    id: encoded.id,
    geo: encoded.geo ? normalizeGeo(encoded.geo) : undefined,
    lightboxPhotoUrl: encoded.lightbox_photo_url,
    mainPhoto: encoded?.main_photo ?? undefined,
    publishedAt: encoded.published_at ? new Date(encoded.published_at) : undefined,
    readingTime: encoded.reading_time,
    scaledPhotoUrl: 'scaled_photo_url' in encoded ? encoded.scaled_photo_url : undefined,
    slug: encoded.slug ?? '',
    tagline: encoded.tagline ?? '',
    title: encoded.title,
    type: encoded.type,
    url: encoded.url ?? '',
    isUgc: encoded.is_ugc ?? false,
  };
};
